import React, { useCallback, useEffect, useState } from 'react'
import proximaReuniao from '../../../../util/proximaReuniao.mp3'
import beep from '../../../../util/beep-09.mp3'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const AudioDialog = (props) => {
    const [authorized, setAuthorized] = useState(false)

    const nextMeetingVoice = () => {
        const audio = new Audio(proximaReuniao)
        audio.play();
    };

    const delay = ms => new Promise(res => setTimeout(res, ms))

    const nextMeetingBeep = useCallback(async () => {
        if (props.tipoConter === "Intervalo" &&
            props.tempoProxima.years === 0 &&
            props.tempoProxima.months === 0 &&
            props.tempoProxima.days === 0 &&
            props.tempoProxima.hours === 0 &&
            props.tempoProxima.minutes === 0 &&
            props.tempoProxima.seconds === 10
        ) {
            const audio = new Audio(beep)
            // let begin = new Date()
            // let beginString = begin.getHours() + ':' + begin.getMinutes() + ':' + begin.getSeconds();
            // console.log('beginString', beginString)


            for (let i = 0; i < 5; i++) {
                audio.play()
                await delay(1500)
            }

            nextMeetingVoice()
            await delay(1500)


            // let end = new Date()
            // let endString = end.getHours() + ':' + end.getMinutes() + ':' + end.getSeconds()
            // console.log('endString', endString)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.tempoProxima, props.tipoConter])

    // const handleOpen = () => {
    //     props.setOpen(true)
    // };

    const handleClose = () => {
        props.setOpen(false)
    };

    const handleAuthorize = () => {
        setAuthorized(true)
        props.setOpen(false)
    };

    const handleUnauthorize = () => {
        setAuthorized(false)
        props.setOpen(false)
    };

    useEffect(() => {
        if (authorized) {
            nextMeetingBeep()
        }
    }, [authorized, nextMeetingBeep])

    return (
        <div>
            {/* <Button variant="contained" color="primary" onClick={handleOpen}>
                Autorizar reprodução de áudio / Alerta Sonoro
            </Button> */}

            <Dialog open={props.open} onClose={handleClose}>
                <DialogTitle>
                    {"Deseja autorizar a reprodução de alerta sonoro?"}
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Ao autorizar, o alerta sonoro será reproduzido automaticamente. Caso contrário, se você optar por não autorizar ou fechar essa caixa de diálogo, o alerta sonoro não será reproduzido.
                        <br /><br />
                        Essa solicitação de autorização garante que você tenha o controle sobre a reprodução de áudio em nosso site. Sua privacidade e experiência são importantes para nós, e respeitamos sua decisão em relação à reprodução de áudio.
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleAuthorize}>Autorizar</Button>
                    <Button onClick={handleUnauthorize}>Não Autorizar</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default AudioDialog